import React, { HTMLProps } from 'react'
import clsx from 'clsx'

import classes from './TextInput.module.scss'

type TextInputProps = HTMLProps<HTMLInputElement> & {
  label: React.ReactNode
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
}

const TextInput = ({
  label,
  placeholder,
  className,
  startIcon,
  endIcon,
  ...props
}: TextInputProps) => {
  return (
    <div className={clsx(classes.root, className)}>
      <div className={clsx(classes.startIconWrapper, classes.iconWrapper)}>
        {startIcon}
      </div>

      <label className={classes.label}>
        <input
          className={classes.input}
          name={name}
          placeholder={placeholder || ' '}
          {...props}
        />

        <span className={classes.labelText}>{label}</span>
      </label>

      <div className={clsx(classes.endIconWrapper, classes.iconWrapper)}>
        {endIcon}
      </div>
    </div>
  )
}

export default TextInput
